<template>
  <div :class="['block-add-cards d-flex', { opened: listOpen }]">
    <div class="btn-blocks-wrapper animated fadeIn" v-if = "listOpen">
      <button class = "blocks-close-btn" @click = "listOpen = !listOpen">
        <v-icon>close</v-icon>
      </button>
      <v-tabs class = "blocks-tabs" color="primary">
        <v-tab v-for = "(tab, t) in tabs" :key = "t" icons-and-text>
          <v-icon style = "min-width: 60px; color: white">{{ tab.icon }}</v-icon>
        </v-tab>
        <v-tab-item v-for = "(tab, t) in tabs" :key = "t" class = "animated bounceInDown add-block-tab" v-if = "listRender">
          <v-card flat>
            <div v-for = "(card, c) in cards" :key = "c" class = "add-block-item" v-if = "card.tabs.indexOf(tab.key) !== -1">
              <button class = "" @click = "card.callback" block style = "margin: 5px 10px; width: 70%;" class = "add-block-btn">
                <span v-if ="card.icon && card.icon.length && !card.isMdIcon" :class = "[ card.icon , 'add-block-btn-icon-span']" />
                <v-icon v-else-if ="card.isMdIcon" class = "add-block-btn-icon-span white--text">{{ card.icon }}</v-icon>
                <v-avatar v-else size="30px" class = "add-block-btn-icon">
                  <v-img :src = "card.img"  />
                </v-avatar>
                <span>{{ card.label }}</span>
              </button>
              <button class = "" @click = "toggleFavouriteCard(card)" block style = "margin: 5px 1px; width: 20%;" class = "add-block-btn">
                <v-icon
                    v-if = "!card.favLoading"
                    :class = "[{ 'warning--text animated rotateIn': card.tabs.indexOf('favourites') !== -1 }]" >star_rate</v-icon>
                <v-progress-circular
                    v-else
                    indeterminate
                    color="primary"
                ></v-progress-circular>
              </button>
            </div>
            <div v-if = "!cards.filter(c => c.tabs.indexOf(tab.key) !== -1).length" style="">
              <p class = "fav-has-no-cards" style="">
                <v-icon>error_outline</v-icon><br>
                <b>{{ tab.label }} tab has no cards.</b>
                <br v-if = "tab.key === 'favourites'">
                <small v-if = "tab.key === 'favourites'" style="width: 180px;display: block;margin: auto;">
                  You can add cards to your favourites from the buttons besides each of them.
                </small>
              </p>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
    <button
        v-if = "!listOpen"
        class="open-btn-blocks animated bounceInDown" :class="{openBtn: listOpen}" @click="listOpen = !listOpen">
      <i class="material-icons" >add</i>
      <span>Add Card</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "add-block",
  props: {
    blocks: {
      type: Object,
      default: ()=> {
        return {}
      }
    }
  },
  data() {
    return {
      listOpen: false,
      listRender: false,
      tabs: [
        {
          key: 'favourites',
          label: 'Favourites',
          icon: 'star_rate',
        },
        {
          key: 'media',
          label: 'Media',
          icon: 'play_circle_outline'
        },
        {
          key: 'others',
          label: 'Others',
          icon: 'grid_on'
        }
      ],
      cards: [
        {
          label: 'Text',
          img: '/img/ic_textcard.png',
          icon: 'botter-text-icon',
          tabs: ['others'],
          callback: this.AddTextCard
        },
        // {
        //   label: 'URL',
        //   img: '/img/ic_gallery-sm.png',
        //   icon: 'botter-link-icon',
        //   tabs: ['others'],
        //   callback: this.AddimageURlCard
        // },
        {
          label: 'Image',
          img: '/img/ic_image.png',
          icon: 'botter-image-icon',
          tabs: ['media'],
          callback: this.AddImageCard
        },
        {
          label: 'Gallery',
          img: '/img/ic_gallery-sm.png',
          icon: 'botter-gallery-icon',
          tabs: ['media'],
          callback: this.AddGalleryCard
        },
        {
          label: 'Video',
          img: '/img/ic_video_round.png',
          icon: 'botter-youtube-icon',
          tabs: ['media'],
          callback: this.AddVideoCard
        },
        {
          label: 'GIF',
          img: '/img/ic_gallery-sm.png',
          icon: 'botter-gif-icon',
          tabs: ['media'],
          callback: this.AddgifCard
        },
        {
          label: 'Suggestion',
          img: '/img/conversation.png',
          icon: 'botter-question-icon',
          tabs: ['others'],
          callback: this.AddSuggestedCard
        },
        {
          label: 'If Else',
          img: '/img/ic_go_to_block_round.png',
          icon: 'botter-if-else-icon',
          tabs: ['others'],
          callback: this.AddGoToCard2
        },
        {
          label: 'Audio',
          img: '/img/ic_audio_round.png',
          icon: 'botter-audio-icon',
          tabs: ['media'],
          callback: this.AddAudioCard
        },
        {
          label: 'Typing',
          img: '/img/ic_typing-sm.png',
          icon: 'botter-Typing-icon',
          tabs: ['others'],
          callback: this.AddTypingCard
        },
        {
          label: 'Attribute',
          img: '/img/attribute.png',
          icon: 'botter-bracket-icon',
          tabs: ['others'],
          callback: this.AddAttrubiteCard
        },
        {
          label: 'User Input',
          img: '/img/ic_r_forms@2x.png',
          icon: 'botter-user-input-icon',
          tabs: ['others'],
          callback: this.AddUserInput
        },
        {
          label: 'Multiline Input',
          img: '/img/ic_r_forms@2x.png',
          icon: 'botter-user-input-icon',
          tabs: ['others'],
          callback: this.AddUserMultiInput
        },
        {
          label: 'JSON',
          img: '/img/ic_r_json.png',
          icon: 'botter-json-icon',
          tabs: ['others'],
          callback: this.AddJsonCard
        },
        {
          label: 'Random',
          img: '/img/Random.png',
          icon: 'botter-shuffle-icon',
          tabs: ['others'],
          callback: this.AddRandom
        },
        {
          label: 'Invoice',
          img: '/img/coin.png',
          icon: 'botter-Billing-icon',
          tabs: ['others'],
          callback: this.AddBillingCard
        },
        {
          label: 'Travel',
          img: '/img/travel.png',
          icon: 'botter-globe-icon',
          tabs: ['others'],
          callback: this.AddTravelCard
        },
        {
          label: 'Flight Status',
          img: '/img/airplane.png',
          icon: 'botter-travel-icon',
          tabs: ['others'],
          callback: this.AddFlightCard
        },
        {
          label: 'Weather',
          img: '/img/weather.png',
          icon: 'botter-Weather-icon',
          tabs: ['others'],
          callback: this.addWeatherCard
        },
        {
          label: 'Map',
          img: '/img/map.png',
          icon: 'map',
          isMdIcon: true,
          tabs: ['others'],
          callback: this.addMapCard
        },
        {
          label: 'Date Time Input',
          img: '/img/date.png',
          isMdIcon: true,
          icon: 'date_range',
          tabs: ['others'],
          callback: this.addDateTimeInputCard
        },
        {
          label: 'Email',
          img: '/img/email.png',
          isMdIcon: true,
          icon: 'email',
          tabs: ['others'],
          callback: this.addEmailCard
        },
        {
          label: 'Escalate',
          img: '/img/escalate.png',
          isMdIcon: true,
          icon: 'headset_mic',
          tabs: ['others'],
          callback: this.addEscalateCard
        },
        {
          label: 'Calendar Booking',
          img: '/img/date.png',
          isMdIcon: true,
          icon: 'date_range',
          tabs: ['others'],
          callback: this.addCalenderBookingCard
        },
        {
          label: 'Book Appointment',
          img: '/img/date.png',
          isMdIcon: true,
          icon: 'date_range',
          tabs: ['others'],
          callback: this.addBookingAppointment
        },
        {
          label: 'Order',
          img: '/img/date.png',
          isMdIcon: true,
          icon: 'shopping_cart',
          tabs: ['others'],
          callback: this.addOrderCard
        },
        {
          label: 'End Conversation',
          img: '/img/escalate.png',
          isMdIcon: true,
          icon: 'speaker_notes_off',
          tabs: ['others'],
          callback: this.addEndConversationCard
        },
        {
          label: 'Attachment',
          img: '/img/escalate.png',
          isMdIcon: true,
          icon: 'botter-paperclip-icon',
          tabs: ['others'],
          callback: this.addAttachmentCard
        },
        {
          label: 'Funnel',
          img: '/img/escalate.png',
          isMdIcon: true,
          icon: 'botter-analysis-icon',
          tabs: ['others'],
          callback: this.addFunnelCard
        },
      ]
    }
  },
  mounted() {
    const localStorageFavCards = localStorage.getItem('favCards')
    if (localStorageFavCards) {
      this.$store.dispatch('setFavCards', JSON.parse(localStorageFavCards))
    }
    this.updateFavList()
  },
  computed: {
    favCards() {
      return this.$store.state.cards.favCards
    }
  },
  watch: {
    listOpen(val) {
      if(val) {
        setTimeout(()=>{ this.listRender = true }, 300)
      } else this.listRender = false
    }
  },
  methods: {
    async toggleFavouriteCard(card) {
      const cardIndex = this.cards.findIndex(c => c.label === card.label)
      this.cards[cardIndex].favLoading = true
      await this.$store.dispatch('toggleFavCard', card.label)
      localStorage.setItem('favCards', JSON.stringify(this.favCards))
      if (this.favCards[card.label] && this.cards[cardIndex].tabs.indexOf('favourites') === -1) {
        this.cards[cardIndex].tabs.push('favourites')
      } else if (!this.favCards[card.label] && this.cards[cardIndex].tabs.indexOf('favourites') !== -1){
        this.cards[cardIndex].tabs.pop()
      }
      this.cards[cardIndex].favLoading = false
    },
    updateFavList() {
      Object.keys(this.favCards).forEach(card => {
        const cardIndex = this.cards.findIndex(c => c.label === card)
        if (this.favCards[card] && this.cards[cardIndex] && this.cards[cardIndex].tabs.indexOf('favourites') === -1) {
          this.cards[cardIndex].tabs.push('favourites')
        } else if (!this.favCards[card] & this.cards[cardIndex] && this.cards[cardIndex].tabs.indexOf('favourites') !== -1){
          this.cards[cardIndex].tabs.pop()
        }
      })
    },
    AddTextCard(){

      this.blocks.payload.push({
        block_id:1,
        data:{
          text:'',
          buttons:[
          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddSuggestedCard(){

      this.blocks.payload.push({
        block_id:17,
        data:{
          text:'',
          buttons:[
            {
              block_id: '',
              errorOrEmpty: "",
              phone: "",
              title: "Untitled Button",
              type: "block",
              url: ""
            }
          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddAudioCard(){
      this.blocks.payload.push({
        block_id:6,
        data:{
          url:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddimageURlCard(){
      this.blocks.payload.push({
        block_id:15,
        data:{
          url:'',
          text:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddgifCard(){
      this.blocks.payload.push({
        block_id:16,
        data:{
          url:'',
          text:'',
          subtitle:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddTypingCard(){
      this.blocks.payload.push({
        block_id:8,
        data:{
          for:1000
        },
        errorOrEmpty:1
      })
      this.listOpen = false
    },
    AddImageCard(){
      this.blocks.payload.push({
        block_id:3,
        data:{
          url:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddGalleryCard(){
      this.blocks.payload.push({
        block_id:4,
        data:{
          items:[
            {
              url:'',
              header:'',
              subtitle:'',
              imageUrl:'',
              buttons:[

              ]
            }
          ],
          errorOrEmpty:0
        }
      })
      this.listOpen = false
    },
    AddVideoCard(){
      this.blocks.payload.push({
        block_id:5,
        data:{
          url:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddGoToCard(){
      this.blocks.payload.push({
        block_id:7,
        data:{
          filter:[],
          blocks:[{
            blocks:[]
          }],
          random:false
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddAttrubiteCard(){
      this.blocks.payload.push({
        block_id:10,
        data:{
          attributes:[
            {
              id:0,
              attribute:'',
              value:''
            }
          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddListCard(){
      this.blocks.payload.push({
        block_id:13,
        data:{
          image:'',
          items:[
            {
              header:'',
              subtitle:'',
              url:'',
              image:'',
              buttons:[

              ]
            }
          ],
          buttons:[

          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddUserInput(){
      this.blocks.payload.push({
        block_id:11,
        data:{
          items:[
            {
              message:'',
              validation:'',
              save_to_attribute:'',
              userAttribute: '',
              regex:'',
              errorMsg: '',
              hasTrialsLimit: false,
              redirectBlock: '',
              numOfTrials: 1
            }
          ],

        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddJsonCard(){
      this.blocks.payload.push({
        block_id:12,
        data:{
          type:'get',
          url:'',
          user_attribute:[],
          report:false,
          attributeFields:[],
          headers: []
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddRandom(){
      this.blocks.payload.push({
        block_id:14,
        data:{
          from : 100,
          to: 200,
          userAttribute:''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddGoToCard2(){
      this.blocks.payload.push({
        block_id:18,
        data:{
          cards:[
            {
              filter:[
              ],
              blocks:[{
                blocks:[]
              }],
              random:false
            }
          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddTravelCard(){
      this.blocks.payload.push({
        block_id:20,
        data:{
          confirmation_number: 'CF23G2',
          currency: 'EGP',
          introMessage: 'welcome to your trip',
          passengers: [ 'ahmed' ],
          details_url: '',
          flight_info: [
            {
              arrival_acronym: 'SLC',
              arrival_date: '2016-01-02T21:20',
              arrival_name: 'Salt Lake City',
              departure_acronym: 'SFO',
              departure_date: '2016-01-02T19:45',
              departure_name: 'San Francisco',
              flight_number: 41,
              stops_number: '5 stops'
            }
          ],
          total: '$4,032.54'
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddFlightCard() {
      this.blocks.payload.push({
        block_id: 22,
        data: {
          status: 'DELAY',
          status_color: '#000',
          passengers: [
            {passenger: 'aml', seat: '12A'},
            {passenger: 'ahmed', seat: '34b'}
          ],
          flight: 'KL0605',
          departs: '10:10AM',
          arrives: '10:10AM',
          travel: {
            originName: 'San Francisco',
            destName: 'Amsterdam',
            originAcronym: 'SFO',
            destAcronym: 'AMS',
          }
        },
        errorOrEmpty: 0
      })
      this.listOpen = false
    },
    AddBillingCard(){
      this.blocks.payload.push({
        block_id: 19,
        data:{
          template_type: 'receipt',
          recipient_name: '',
          order_number: '',
          currency: 'USD',
          payment_method: 'Visa 2345',
          timestamp: '1428444852',
          address: {
            street_1: '1 Hacker Way',
            street_2: '',
            city: 'Menlo Park',
            postal_code: '94025',
            state: 'CA',
            country: 'US'
          },
          summary: {
            subtotal: 75,
            shipping_cost: 4.95,
            total_tax: 6.19,
            total_cost: 56.14
          },
          adjustments: [

          ],
          elements: [
            {
              title: 'Classic White T-Shirt',
              subtitle: '100% Soft and Luxurious Cotton',
              quantity: 2,
              price: 50,
              currency: 'USD',
              image_url: 'http://petersapparel.parseapp.com/img/whiteshirt.png'
            },
          ]
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addWeatherCard () {
      this.blocks.payload.push({
        block_id:21,
        data:{
          area: '',
          imageUrl: '',
          temp: '',
          hiTemp: '',
          lowTemp: ''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    AddUserMultiInput(){
      this.blocks.payload.push({
        block_id:23,
        data:{
          message:'',
          save_to_attribute:'',
          userAttribute: '',
          stopWord:'',
          errorMsg: ''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addMapCard () {
      this.blocks.payload.push({
        block_id:24,
        data:{
          buttonTitle: '',
          title: '',
          description: '',
          lat: '',
          lon: '',
          imageUrl: ''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addDateTimeInputCard () {
      this.blocks.payload.push({
        block_id:25,
        data:{
          message:'',
          hasTime: false,
          buttonTitle: '',
          save_to_attribute: '',
          errorMessage: '',
          cancelButtonLabel: '',
          cancelRedirectBlock: '',
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addEscalateCard () {
      this.blocks.payload.push({
        block_id:26,
        data:{
          queueName: '',
          blocksFinishing: [],
          blocksNotAvailable: [],
          blocksNotAnswering: []
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addEndConversationCard () {
      this.blocks.payload.push({
        block_id: 29,
        data: {}
      })
      this.listOpen = false
    },
    addEmailCard () {
      this.blocks.payload.push({
        block_id:27,
        data:{
          to: '',
          cc: '',
          bcc: '',
          subject: '',
          bodyText: '',
          bodyAttributes: [],
          useTemplate: false
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addAttachmentCard () {
      this.blocks.payload.push({
        block_id:28,
        data:{
          url: '',
          fileName: ''
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addCalenderBookingCard () {
      this.blocks.payload.push({
        block_id:30,
        data:{
          message:'',
          buttonTitle: '',
          save_to_attribute_time: '',
          save_to_attribute_date: '',
          errorMessage: '',
          extensionTitle: '',
          extensionMessage: '',
          cancelButtonLabel: '',
          cancelRedirectBlock: '',
          request: {
            type:'get',
            url:'',
            user_attribute:[],
            headers: []
          }
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addOrderCard() {
      this.blocks.payload.push({
        block_id:32,
        data:{
          buttonTitle: '',
          errorMessage: '',
          extensionTitle: '',
          extensionMessage: '',
          extensionImage: '',
          save_to_attribute_cart: '',
          save_to_attribute_cost: '',
          currentBranch: '',
          branches: [],
          cancelButtonLabel: '',
          cancelRedirectBlock: '',
          requestGetProducts: {
            type:'get',
            url:'',
            user_attribute:[],
            headers: []
          },
          requestGetOrder: {
            type:'get',
            url:'',
            user_attribute:[],
            headers: []
          },
          requestSubmitOrder: {
            type:'post',
            url:'',
            user_attribute:[],
            headers: []
          },
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addFunnelCard() {
      this.blocks.payload.push({
        block_id:31,
        data:{
          name: '',
          attributes: []
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },
    addBookingAppointment () {
      this.blocks.payload.push({
        block_id:33,
        data:{
          buttonTitle: '',
          extensionTitle: '',
          extensionMessage: '',
          extensionImage: '',
          cancelButtonLabel: '',
          cancelRedirectBlock: '',
          nextButtonLabel:'',
          bookingButtonLabel: '',
          errorMessage: '',
          successfulBlockRedirect: '',
          step1: {
            name:'',
            icon:'',
            title:'',
            selectedIdAttribute: '',
            selectedNameAttribute: '',
            request: {
              type:'get',
              url:'',
              user_attribute:[],
              headers: []
            }
          },
          step2: {
            name:'',
            icon:'',
            title:'',
            selectedIdAttribute: '',
            selectedNameAttribute: '',
            selectedCodeAttribute:'',
            request: {
              type:'get',
              url:'',
              user_attribute:[],
              headers: []
            }
          },
          step3: {
            name:'',
            icon:'',
            title:'',
            selectedDateAttribute: '',
            selectedTimeAttribute: '',
            selectedWorkDayAttribute: '',
            request: {
              type:'get',
              url:'',
              user_attribute:[],
              headers: []
            }
          },
        },
        errorOrEmpty:0
      })
      this.listOpen = false
    },

  }
}
</script>

<style scoped>

</style>
